export default "__VITE_ASSET__9cEPq20A__";